import { User } from '@/models'
import { UsesAuthenticatedUser } from '@/mixins/index'

export default {
  mixins: [ UsesAuthenticatedUser ],

  created () {
    if (!this.$store.state.myKintell.userActivitySession) {
      const userActivitySession = Math.random().toString(36).substring(2)
      this.$store.commit('myKintell/SET_USER_ACTIVITY_SESSION', userActivitySession)
    }
  },
  methods: {
    sendUserActivity (data) {
      data.session = this.$store.state.myKintell.userActivitySession
      return (new User()).action('activity', data)
    },

    sendInitiateReport ({ name, extra = {}, kintellCard = null }) {
      let payloadExtra = {
        ...extra,
      }

      if (kintellCard) {
        payloadExtra = {
          ...payloadExtra,
          kintellCardId: kintellCard.id,
        }

        if (kintellCard.kintellGroupId) {
          payloadExtra.kintellGroupId = kintellCard.kintellGroupId
        }
      }

      return this.sendUserActivity({
        type: 'initiate',
        activity_id: this.authenticatedUser.id,
        name,
        extra: payloadExtra,
      })
    }
  }
}
